import React from "react";
import "./SignUp.scss";
import FirstFormStep from "./FirstFormStep";
import SecondFormStep from "./SecondFormStep";
import MainBonusBox from "./MainBonusBox";

function SignUp() {
  const [currentStep, setCurrentStep] = React.useState(1);

  return (
    <div className='app-full-content'>
      <div className='signup-page-content'>
        <div className='box-frame-signup'>
          <h4>Sign Up</h4>
          <MainBonusBox />
          {currentStep === 1 ? (
            <FirstFormStep
              onClickButton={() => {
                setCurrentStep(2);
              }}
            />
          ) : (
            <SecondFormStep />
          )}
        </div>
      </div>
    </div>
  );
}

export default SignUp;
